import React, { useEffect, useState } from "react";
import { formatAMPM } from "../Functionalities/Functions";
import {
  DEFAULT_CANCEL_WINDOW_MINUTES,
  orderTimeBadge,
  EDITED_COLOR,
  editedLabel,
} from "../Functionalities/orderBadges";
import OrderTag from "./OrderTag";
import { customerDetailsVisible } from "../Functionalities/orderVisibility";
import { useNow } from "../Functionalities/useNow";
import { orderNoteLines } from "../Pages/Order/Logic";
import {
  is_superuser,
  is_franchise_admin,
  is_franchise_manager,
  is_franchise_staff,
  has_franchise_reach,
  is_shop_admin,
  is_shop_manager,
} from "../Functionalities/Config";
import Lottie from "react-lottie";
import blackAnimation from "../../src/Assets/lottie/blackAnimation.json";
import blueAnimation from "../../src/Assets/lottie/blueAnimation.json";
import greenAnimation from "../../src/Assets/lottie/greenAnimation.json";
import greyAnimation from "../../src/Assets/lottie/greyAnimation.json";
import purpleAnimation from "../../src/Assets/lottie/purpleAnimation.json";
import redAnimation from "../../src/Assets/lottie/redAnimation.json";
import yellowAnimation from "../../src/Assets/lottie/yellowAnimation.json";
import TimeAgo from "javascript-time-ago";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

import en from "javascript-time-ago/locale/en";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { changeRestaurantStatus } from "../Functionalities/OrderFunctions";
import FoodReadyControl from "./FoodReadyControl";
import { orderAddressLine, orderLandmark } from "../Functionalities/orderAddress";
import {
  restaurantCellBackground,
} from "../Functionalities/restaurantStatus";

TimeAgo.addLocale(en);

function OrderListingComponent({
  item,
  accept,
  reject,
  cutomerOrder,
  onRestaurantStatusChange,
  cancelWindowMinutes = DEFAULT_CANCEL_WINDOW_MINUTES,
}) {
  const [foodReadyAt, setFoodReadyAt] = useState(item.food_ready_at || null);

  useEffect(() => {
    setFoodReadyAt(item.food_ready_at || null);
  }, [item.food_ready_at]);

  // Ticks on the shared page clock so "placed 24 minutes ago" turns yellow at
  // 25 without waiting for something else to re-render the list. A scheduled
  // order shows its countdown instead of its age.
  const now = useNow();
  const timeBadge = orderTimeBadge(item, new Date(now), cancelWindowMinutes);

  const showCustomer = customerDetailsVisible({
    isPrivileged: is_superuser || is_franchise_admin || is_franchise_manager,
    isStaff: is_franchise_staff,
  });

  const noteLines = orderNoteLines(item);
  const popover = (
    <Popover id="popover-positioned-left" title="Order notes">
      {noteLines.map((line) => (
        <div key={line.label}>
          <b>{line.label}:</b> {line.text}
        </div>
      ))}
    </Popover>
  );

  // const changeRestaurantStatus = (order, status) => {
  //   let data = new FormData();
  //   data.append("id", order.id);
  //   data.append("key", "restaurant_approved_status");
  //   data.append("value", status);

  //   const config = {
  //     method: "patch",
  //     url: `${url}/order/order-update/`,
  //     data,
  //     headers: { Authorization: token },
  //   };

  //   axios(config)
  //     .then((res) => {
  //       void 0
  //     })
  //     .catch((err) => void 0);
  // };

  const showStatusConfirm = (order, status) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div
            className="custom-ui"
            style={{
              borderRadius: 8,
              border: "1px solid #ccc",
              padding: 40,
              maxWidth: 400,
              margin: "auto",
              textAlign: "center",
              backgroundColor: "#fff",
            }}
          >
            <h2>Are you sure you want to change the status?</h2>
            <p>Press continue to proceed.</p>
            <div style={{ marginTop: 30 }}>
              {order?.restaurant_approved_status !== "declined" && (
                <button
                  onClick={() =>
                    changeRestaurantStatus(order?.id, "declined", () => {
                      onClose();
                      if (onRestaurantStatusChange) onRestaurantStatusChange();
                    })
                  }
                  className="btn btn-secondary"
                  style={{ marginRight: 15 }}
                >
                  Reject
                </button>
              )}
              <button
                onClick={() =>
                  changeRestaurantStatus(order?.id, "approved", () => {
                    onClose();
                    if (onRestaurantStatusChange) onRestaurantStatusChange();
                  })
                }
                className="btn btn-primary"
              >
                Approve
              </button>
            </div>
          </div>
        );
      },
    });
  };

  return (
    <>
      <tr
        className={
          item.order_type == "ONLINE" &&
          item.actual_amount_collected + item.wallet_amount !== item.net_amount
            ? "alert order-suspicious"
            : "alert alert-dismissible"
        }
      >
        <td className="order-detail-cell">
          <a href={`/orderID/${item.id}`}>
            <h6 class="fs-15 mb-0" className={"row "}>
              <span>
                <Lottie
                  title={item.status ? item.status.name : ""}
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData:
                      (item.status.name == "pending" && redAnimation) ||
                      (item.status.name == "approved" && yellowAnimation) ||
                      (item.status.name == "delivered" && greenAnimation) ||
                      (item.status.name == "declined" && blackAnimation) ||
                      (item.status.name == "out for delivery" &&
                        purpleAnimation) ||
                      (item.status.name == "cancelled" && greyAnimation) ||
                      (item.status.name == "delivery boy assigned" &&
                        blueAnimation),
                    rendererSettings: {
                      preserveAspectRatio: "xMidYMid slice",
                    },
                  }}
                  height={30}
                  width={30}
                />
                {/* <br /> */}
                FDR{item.id}
                <br />
                <br />
                {timeBadge && (
                  <span
                    style={{
                      color: timeBadge.color,
                      border: `2px solid ${timeBadge.color}`,
                      padding: "5px",
                      borderRadius: "8px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {timeBadge.text}
                  </span>
                )}
                {item.is_first_order && (
                  <>
                    <br />
                    <OrderTag color="#6A1B9A">First order</OrderTag>
                  </>
                )}
                {editedLabel(item.edit_count) && (
                  <>
                    <br />
                    <OrderTag color={EDITED_COLOR} title="Items were changed after the order was placed">
                      {editedLabel(item.edit_count)}
                    </OrderTag>
                  </>
                )}
              </span>
            </h6>
          </a>
        </td>

        <td className="order-detail-cell">
          <a href={`/orderID/${item.id}`}>
            <span className="text-primary">
              <strong style={{ textTransform: "capitalize", color: "black" }}>
                {item.status ? item.status.name : "NA"}
              </strong>
              <br />

              {new Date(item.date).toLocaleDateString()}
              <br />
              {formatAMPM(new Date(item.date))}
              {item.scheduled_slot && (
                <>
                  <br />
                  <span
                    style={{
                      color: "purple",
                      border: "2px solid purple",
                      padding: "3px 5px",
                      borderRadius: "8px",
                      display: "inline-block",
                      marginTop: "6px",
                      fontWeight: "bold",
                    }}
                  >
                    Scheduled:{" "}
                    {new Date(
                      item.scheduled_slot.scheduled_date
                    ).toLocaleDateString()}{" "}
                    {formatAMPM(
                      new Date(`1970-01-01T${item.scheduled_slot.from_time}`)
                    )}{" "}
                    -{" "}
                    {formatAMPM(
                      new Date(`1970-01-01T${item.scheduled_slot.to_time}`)
                    )}
                  </span>
                </>
              )}
            </span>
          </a>
        </td>

        {showCustomer && (
          <td className="order-detail-cell">
            {!cutomerOrder ? (
              <div className="d-flex justify-content-between">
                <a
                  style={{
                    wordWrap: "break-word",
                    color: "#101010",
                    fontWeight: "bold",
                  }}
                  href={`/orderID/${item.id}`}
                >
                  {item.user.first_name} -{" "}
                  {item.user.details ? item.user.details.mobile : ""}
                  {item.receiver_phone ? ` · call ${item.receiver_phone}` : ""}
                </a>
                {item.contact_abroad && (
                  <span
                    className="badge badge-danger ml-1"
                    title={`Customer abroad: online payment, WhatsApp ${item.whatsapp_number || ""}`}
                  >
                    WhatsApp
                  </span>
                )}
                {noteLines.length > 0 && (
                  <OverlayTrigger
                    trigger="click"
                    placement="bottom"
                    overlay={popover}
                  >
                    <button className="btn p-1">
                      <svg
                        id="icon-orders"
                        xmlns="http://www.w3.org/2000/svg"
                        width={20}
                        height={20}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        color="#000"
                        strokeLinejoin="round"
                        className="feather feather-file-text"
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <polyline points="14 2 14 8 20 8" />
                        <line x1={16} y1={13} x2={8} y2={13} />
                        <line x1={16} y1={17} x2={8} y2={17} />
                        <polyline points="10 9 9 9 8 9" />
                      </svg>
                    </button>
                  </OverlayTrigger>
                )}
              </div>
            ) : null}
            <br />
            <a
              style={{
                display: "block",
                textOverflow: "ellipsis(2)",
                wordWrap: "break-word",
                color: "blue",
                fontWeight: "bold",
                // width: "50%"
              }}
              href={`/orderID/${item.id}`}
            >
              {orderLandmark(item)}
            </a>
            <a
              style={{
                display: "block",
                textOverflow: "ellipsis(2)",
                wordWrap: "break-word",
                fontSize: item.self_pickup ? "14px" : "12px",
                fontWeight: item.self_pickup ? "bold" : undefined,
                // width: "50%"
              }}
              href={`/orderID/${item.id}`}
            >
              {orderAddressLine(item)}
            </a>
            <br />
          </td>
        )}
        <td className="order-detail-cell">
          <a href={`/orderID/${item.id}`}>
            <span className="text-primary">
              {item.delivery_boy
                ? item.delivery_boy.first_name
                : "Not assigned"}
            </span>
            <br />
            {(is_superuser || has_franchise_reach) && (
              <a href={`/orderID/${item.id}`} style={{ width: "50%" }}>
                {item.delivery_boy?.details.mobile}
              </a>
            )}
          </a>
        </td>

        {(is_superuser || has_franchise_reach) && (
          <td
            style={{
              background: restaurantCellBackground(item),
              textAlign: "center",
            }}
          >
            <a href={`/orderID/${item.id}`}>
              {is_superuser && (
                <p className="m-0 mb-2" style={{ color: "black" }}>
                  {item.franchise.name}
                </p>
              )}

              <p className="text-primary m-0 mb-2">{item.branch.name}</p>
            </a>
            <div className="mb-2">
              <FoodReadyControl order={item} foodReadyAt={foodReadyAt} onChange={setFoodReadyAt} />
            </div>
            {/* <br /> */}
            {(is_superuser || has_franchise_reach) && (
              <a href={`/orderID/${item.id}`} style={{ width: "50%" }}>
                {item.branch.mobile}
              </a>
            )}
          </td>
        )}

        {(is_superuser || has_franchise_reach) && (
          <td className="order-detail-cell">
            <a href={`/orderID/${item.id}`}>₹ {item.net_amount} </a>
          </td>
        )}

        {/* restaurant accept or reject */}
        {(sessionStorage.getItem("unattended") === "true" ||
          sessionStorage.getItem("rejected") === "true") &&
          has_franchise_reach && (
            <td onClick={() => showStatusConfirm(item)}>✅ or ❌</td>
          )}

        <td>
          {(has_franchise_reach || is_shop_admin || is_shop_manager) &&
            item.status.name == "pending" && (
              <div className="dropdown">
                <a
                  href="javascript:void(0)"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z"
                      stroke="#3E4954"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18 12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12Z"
                      stroke="#3E4954"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12Z"
                      stroke="#3E4954"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>

                {(has_franchise_reach || is_shop_admin || is_shop_manager) && (
                  <div className="dropdown-menu dropdown-menu-right">
                    <a
                      onClick={accept}
                      className="dropdown-item"
                      // href="javascript:void(0);"
                      style={{ cursor: "pointer" }}
                    >
                      <i className="las la-check-circle text-success mr-3 scale5" />
                      Accept Order
                    </a>
                    <a
                      onClick={reject}
                      className="dropdown-item"
                      style={{ cursor: "pointer" }}
                    >
                      <i className="las la-times-circle text-danger mr-3 scale5" />
                      Reject Order
                    </a>
                  </div>
                )}
              </div>
            )}
        </td>
      </tr>
    </>
  );
}

export default OrderListingComponent;
